import UploadValidationRepository from '@/domain/repositories/UploadValidationRepository';
import UploadValidationDataStore from '../datastores/UploadValidationDataStore';
import UploadValidationDataStoreFactory from '../factories/UploadValidationStoreFactory';

export default class UploadValidationDataRepository
  implements UploadValidationRepository
{
  uploadValidation(imgBase64: string) {
    const uploadValidationDataStore: UploadValidationDataStore =
      UploadValidationDataStoreFactory.create();
    return uploadValidationDataStore.uploadValidation(imgBase64);
  }
}
